/* @ngInject */
function GroupsAdminController ($scope, $q, $state, $translate, $timeout, ToastService, UdsModalService, GroupService) {
  const getNewGroupDialogController = () => $q.when(import('../../dialogs/new-group/new-group-dialog.controller'))
  const getDeleteGroupDialogController = () => $q.when(import('../../dialogs/delete-group/delete-group-dialog.controller'))

  $scope.bUserNotAuthorized = false
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.limit = 3
  $scope.loading = true
  $scope.searchInput = ''
  $scope.sort = {
    $sort: 'createdAt',
    $order: 'DESC'
  }
  $scope.flags = {
    bIsSearchHappening: false
  }

  const api = {
    getNewGroupDialogController,
    getDeleteGroupDialogController,
    _handleGetGroupsError,
    _handleGetGroupsResponse,
    _skipPagingTo,
    _openNewGroupDialog,
    _deleteGroup,
    _updateFilters,
    _updateSort,
    _onSearchGroups
  }
  this.getApi = () => api

  $scope.tableInfo = {
    tooltip: '',
    emptyMode: {
      title: $translate.instant('noGroupsFound'),
      description: $translate.instant('groupDescription'),
      button: {
        text: $translate.instant('createGroup'),
        icon: 'users',
        buttonClick: api._openNewGroupDialog
      }
    },
    columns: [
      { name: $translate.instant('name'), orderable: false, value: 'name' },
      { name: $translate.instant('users'), orderable: false, value: 'users' },
      { name: $translate.instant('createdIn'), orderable: true, value: 'createdIn' }
    ],
    columnsGrid: '40% 25% 30% 5%',
    rows: [],
    editButton: {
      editGroupClick: api._openNewGroupDialog,
      deleteGroupClick: api._deleteGroup,
      dropdown: false
    },
    refresherCounter: 0,
    paging: {
      top: 16,
      count: 0,
      index: 0,
      onTokenSelect: api._skipPagingTo
    },
    updateSort: api._updateSort
  }

  $scope.headerToolbar = {
    rightButtons: [{
      type: 'button',
      btnType: 'primary',
      icon: 'plus',
      label: $translate.instant('createGroup'),
      onClick: api._openNewGroupDialog
    }],
    search: {
      onSearch: api._onSearchGroups
    }
  }

  $scope.skipPagingTo = api._skipPagingTo
  $scope.pageTitle = ''

  api._skipPagingTo(null, 0)

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('groups')
  })

  function _handleGetGroupsResponse (res) {
    $scope.tableInfo.paging.count = res.d.__count

    $scope.tableInfo.rows = res.d.results.map(group => {
      return {
        id: group.id,
        name: group.name,
        users: [...group.users],
        values: [
          { type: 'TEXT', value: group.name },
          { type: 'COUNT_LABEL', value: group.users.length, label: $translate.instant('users') },
          { type: 'DATE', value: group.createdAt, extended: true }
        ]
      }
    })

    $scope.loading = false
    $timeout(() => {
      $scope.$broadcast('core-table.updateGrid')
    }, 0)
  }

  function _handleGetGroupsError (oError) {
    $scope.loading = false
    if (oError && oError.status === 403) {
      $scope.bUserNotAuthorized = true
    }
  }

  function _skipPagingTo (event, token) {
    token = event ? event.detail.currentPage - 1 : token
    $scope.tableInfo.paging.index = token

    $scope.loading = true
    GroupService.getGroups(
      $scope.tableInfo.paging.top,
      $scope.tableInfo.paging.top * token,
      { searchTerm: $scope.searchInput, ...$scope.sort },
      false
    ).then(api._handleGetGroupsResponse).catch(api._handleGetGroupsError)
  }

  function _deleteGroup (group) {
    api.getDeleteGroupDialogController().then(({ DeleteGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: DeleteGroupDialogController,
        modalName: 'deleteGroupDialog',
        data: {
          group
        },
        onClose: (wasDeleted) => {
          if (wasDeleted) {
            ToastService.defaultSuccessToast()
            api._skipPagingTo(null, 0)
          }
        }
      })
      modal.open()
    })
  }

  function _openNewGroupDialog (oGroup) {
    const group = oGroup?.users ? oGroup : null

    api.getNewGroupDialogController().then(({ NewGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: NewGroupDialogController,
        modalName: 'newGroupDialog',
        data: {
          group
        },
        onClose: (bEmailSuccessfullySent) => {
          if (bEmailSuccessfullySent) {
            ToastService.showSuccessToast($translate.instant('successTitle'))
            api._skipPagingTo(null, 0)
          }
        }
      })
      modal.open()
    })
  }

  function _onSearchGroups (term) {
    api._updateFilters('search', term)
  }

  function _updateFilters (filter, value) {
    $scope.searchInput = value
    $scope.flags.bIsSearchHappening = true
    api._skipPagingTo(null, 0)
  }

  function _updateSort (newSort) {
    $scope.sort = newSort
    api._skipPagingTo(null, $scope.tableInfo.paging.index)
  }
}

export { GroupsAdminController }
